import { toast } from "react-toastify";

function ToastEmitter({ msg, type }) {
	toast[type](
		(typeof msg === "string" && msg) || "Error occurred. Please try again.",
		{
			position: "bottom-center",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			transaction: "Zoom",
			progress: undefined,
			theme: "colored",
		}
	);
}

export { ToastEmitter };
